var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _class, _temp2, _initialiseProps;

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { withStateMachine } from 'react-automata';
import statechart, { EVENTS, STATES } from './statechart';
import { LOAD_POLICIES, getCachedResponseFromProps } from './utils';

export default withStateMachine(statechart)((_temp2 = _class = function (_Component) {
  _inherits(Loads, _Component);

  function Loads() {
    var _temp, _this, _ret;

    _classCallCheck(this, Loads);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _Component.call.apply(_Component, [this].concat(args))), _this), _initialiseProps.call(_this), _temp), _possibleConstructorReturn(_this, _ret);
  }

  return Loads;
}(Component), _class.propTypes = {
  cachedResponse: PropTypes.shape({
    error: PropTypes.any,
    response: PropTypes.any,
    state: PropTypes.oneOf([STATES.SUCCESS, STATES.ERROR])
  }),
  children: PropTypes.oneOfType([PropTypes.func, PropTypes.node]).isRequired,
  contextKey: PropTypes.string,
  delay: PropTypes.number,
  enableBackgroundStates: PropTypes.bool,
  getCachedResponse: PropTypes.func,
  isErrorSilent: PropTypes.bool,
  load: PropTypes.func,
  loadOnMount: PropTypes.bool,
  loadPolicy: PropTypes.oneOf(['cache-first', 'cache-and-load', 'load-only']),
  machineState: PropTypes.object.isRequired,
  setResponse: PropTypes.func,
  timeout: PropTypes.number,
  transition: PropTypes.func.isRequired,
  update: PropTypes.oneOfType([PropTypes.array, PropTypes.func]),
  Provider: PropTypes.object.isRequired
}, _class.defaultProps = {
  cachedResponse: null,
  contextKey: null,
  delay: 300,
  enableBackgroundStates: false,
  getCachedResponse: null,
  isErrorSilent: true,
  load: null,
  loadOnMount: false,
  loadPolicy: LOAD_POLICIES.CACHE_AND_LOAD,
  setResponse: null,
  timeout: 0,
  update: null
}, _class.getDerivedStateFromProps = function (nextProps, state) {
  if (nextProps.contextKey !== state.contextKey) {
    return _extends({
      contextKey: nextProps.contextKey
    }, getCachedResponseFromProps(nextProps));
  }
  if (nextProps.cachedResponse && !state.hasResponseInCache) {
    return getCachedResponseFromProps(nextProps);
  }
  return {};
}, _initialiseProps = function _initialiseProps() {
  var _this2 = this;

  this._count = 0;
  this.state = _extends({
    contextKey: this.props.contextKey
  }, getCachedResponseFromProps(this.props));

  this.componentDidMount = function () {
    var loadOnMount = _this2.props.loadOnMount;

    _this2._mounted = true;
    if (loadOnMount) {
      _this2._count = _this2._count + 1;
      _this2.handleLoad({ count: _this2._count })();
    }
  };

  this.componentDidUpdate = function (prevProps) {
    var prevContextKey = prevProps.contextKey;
    var _props = _this2.props,
        contextKey = _props.contextKey,
        loadOnMount = _props.loadOnMount;


    if (contextKey && contextKey !== prevContextKey) {
      if (loadOnMount) {
        _this2._count = _this2._count + 1;
        _this2.handleLoad({ count: _this2._count })();
      }
    }
  };

  this.componentWillUnmount = function () {
    _this2._clearTimeouts();
    _this2._mounted = false;
  };

  this._clearTimeouts = function () {
    clearTimeout(_this2._delayTimeout);
    clearTimeout(_this2._timeoutTimeout);
  };

  this._setTimeouts = function () {
    var _props2 = _this2.props,
        delay = _props2.delay,
        timeout = _props2.timeout;

    if (delay) _this2._paused = true;
    _this2._delayTimeout = setTimeout(function () {
      _this2._paused = false;
      _this2.transition(EVENTS.FETCH);
    }, delay);
    if (timeout) {
      _this2._timeoutTimeout = setTimeout(function () {
        _this2.transition(EVENTS.TIMEOUT);
        _this2._clearTimeouts();
      }, timeout);
    }
  };

  this.handleLoad = function (_ref) {
    var count = _ref.count,
        deferredFn = _ref.deferredFn;
    return function () {
      for (var _len2 = arguments.length, args = Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
        args[_key2] = arguments[_key2];
      }

      var _props3 = _this2.props,
          isErrorSilent = _props3.isErrorSilent,
          baseFn = _props3.load,
          loadPolicy = _props3.loadPolicy;
      var hasResponseInCache = _this2.state.hasResponseInCache;


      if (loadPolicy === LOAD_POLICIES.CACHE_FIRST && hasResponseInCache) return null;
      if (_this2._paused) return null;

      _this2._setTimeouts();

      var fn = deferredFn || baseFn;
      return fn.apply(undefined, args.concat([{
        setError: function setError(opts, cb) {
          return _this2.handleOptimisticResponse(_extends({}, opts, { count: count, data: opts.error, event: EVENTS.ERROR }), cb);
        },
        setResponse: function setResponse(opts, cb) {
          return _this2.handleOptimisticResponse(_extends({}, opts, { count: count, event: EVENTS.SUCCESS }), cb);
        }
      }])).then(function (response) {
        _this2.handleResponse({ count: count, response: response, event: EVENTS.SUCCESS });
        return response;
      }).catch(function (err) {
        _this2.handleResponse({ count: count, error: err, event: EVENTS.ERROR });
        if (!isErrorSilent) {
          throw err;
        }
      });
    };
  };

  this.handleUpdate = function (_ref2) {
    var count = _ref2.count;
    var update = _this2.props.update;

    if (Array.isArray(update)) {
      return update.map(function (deferredFn) {
        return _this2.handleLoad({ count: count, deferredFn: deferredFn });
      });
    }
    return _this2.handleLoad({ count: count, deferredFn: update });
  };

  this.handleResponse = function (_ref3) {
    var contextKey = _ref3.contextKey,
        count = _ref3.count,
        error = _ref3.error,
        event = _ref3.event,
        response = _ref3.response;
    var setResponse = _this2.props.setResponse;

    if (!_this2._mounted) return;
    if (_this2._count !== count) return;
    var value = _extends({}, event === EVENTS.SUCCESS ? { response: response } : {}, event === EVENTS.ERROR ? { error: error } : {});
    _this2._clearTimeouts();
    _this2._paused = false;
    _this2.setState(value);
    setResponse && setResponse(_extends({
      contextKey: contextKey
    }, value, event === EVENTS.SUCCESS ? { state: STATES.SUCCESS } : {}, event === EVENTS.ERROR ? { state: STATES.ERROR } : {}));
    _this2.transition(event);
  };

  this.handleOptimisticResponse = function (_ref4, cb) {
    var contextKey = _ref4.contextKey,
        count = _ref4.count,
        data = _ref4.data,
        event = _ref4.event;
    var _props4 = _this2.props,
        currentContextKey = _props4.contextKey,
        getCachedResponse = _props4.getCachedResponse,
        setResponse = _props4.setResponse;


    var newData = data;
    if (typeof data === 'function' && getCachedResponse) {
      var cachedData = getCachedResponse({ contextKey: contextKey }) || {};
      if (cachedData) {
        newData = data(cachedData.response);
      }
    }

    var value = _extends({}, event === EVENTS.SUCCESS ? { response: newData } : {}, event === EVENTS.ERROR ? { error: newData } : {});
    if (!contextKey || contextKey === currentContextKey) {
      _this2.handleResponse(_extends({ contextKey: contextKey, count: count, event: event }, value));
    } else {
      setResponse && setResponse(_extends({
        contextKey: contextKey
      }, value, event === EVENTS.SUCCESS ? { state: STATES.SUCCESS } : {}, event === EVENTS.ERROR ? { state: STATES.ERROR } : {}));
    }

    cb && cb(newData);
  };

  this.transition = function (event) {
    var transition = _this2.props.transition;

    if (!_this2._mounted) {
      return;
    }
    transition(event);
  };

  this.render = function () {
    var _props5 = _this2.props,
        enableBackgroundStates = _props5.enableBackgroundStates,
        cachedResponse = _props5.cachedResponse,
        children = _props5.children,
        machineState = _props5.machineState,
        Provider = _props5.Provider;
    var _state = _this2.state,
        error = _state.error,
        hasResponseInCache = _state.hasResponseInCache,
        response = _state.response;

    var cachedState = cachedResponse ? cachedResponse.state : null;
    var state = machineState.value;
    var props = {
      state: state,
      error: error,
      response: response,
      hasResponseInCache: hasResponseInCache,
      isIdle: state === STATES.IDLE && (!hasResponseInCache || enableBackgroundStates),
      isLoading: state === STATES.LOADING && (!hasResponseInCache || enableBackgroundStates),
      isTimeout: state === STATES.TIMEOUT && (!hasResponseInCache || enableBackgroundStates),
      isSuccess: state === STATES.SUCCESS || hasResponseInCache && cachedState === STATES.SUCCESS,
      isError: state === STATES.ERROR || hasResponseInCache && cachedState === STATES.ERROR,
      load: _this2.handleLoad({ count: _this2._count }),
      update: _this2.handleUpdate({ count: _this2._count }),
      resetState: function resetState() {
        return _this2.transition(EVENTS.RESET);
      }
    };
    return React.createElement(
      Provider,
      { value: props },
      typeof children === 'function' ? children(props) : children
    );
  };
}, _temp2));